import { Breadcrumbs } from "@/components/page";
import { TaskViews } from "@/components/tasks/TaskViews";
import { PageSpinner } from "@/components/ui";
import { TASK_AREAS, type TaskArea } from "@/lib/areas";
import { useProject } from "@/lib/project";
import { useEpics } from "@/lib/queries";

/** Board and table of one built-in task area (Management, Infra & Security). */
export function AreaPage({ area }: { area: TaskArea }) {
  const { pid, bundle } = useProject();
  const epics = useEpics(pid);
  const meta = TASK_AREAS[area];
  const epic = epics.data?.find((e) => e.area === area);

  return (
    <>
      <Breadcrumbs items={[{ label: bundle.project.name, to: `/p/${pid}` }, { label: meta.title }]} />
      <div className="px-6 pt-8 pb-4 md:px-12">
        <h1 className="flex items-center gap-2.5 text-[32px] leading-tight font-bold">
          <meta.icon className="size-7 shrink-0 text-muted" />
          {meta.title}
        </h1>
        <p className="mt-1 text-sm text-muted">{meta.description} Finished tasks here count toward team pay like any other task.</p>
      </div>
      <div className="pb-24">
        {epics.isPending ? (
          <PageSpinner />
        ) : epic ? (
          <TaskViews key={epic.id} scope={{ epicId: epic.id }} storageKey={`view:${pid}:area:${area}`} createIn={{ epicId: epic.id, sprintId: null }} />
        ) : (
          <p className="px-6 text-sm text-muted md:px-12">This area isn't available for this project.</p>
        )}
      </div>
    </>
  );
}
